export const defaultMenuType = {
  name: "",
  general_type: "",
  poredak: null
};

export const generalTypes = [
  { id: 'complete_meal', name: 'complete_meal' },
  { id: 'guest_meal', name: 'guest_meal1' },
  { id: 'group', name: 'group1' },
  { id: 'group_food', name: 'group_food' },
  { id: 'more_restaurants', name: 'more_restaurants1' },
  { id: 'table', name: 'table1' },
];
